import React from "react";

import { useToastContext } from "@shared/context/ToastContext";

import SettingsContainer from "@ats/src/components/shared/SettingsContainer";
import UnsavedChangesGuard from "@ats/src/components/shared/UnsavedChangesGuard";
import Button from "@ats/src/components/shared/Button";
import FormInput from "@ats/src/components/forms/FormInput";
import FormSection from "@ats/src/components/forms/FormSection";
import ConfirmationModal from "@ats/src/components/modals/ConfirmationModal";
import LoadingIndicator from "@ats/src/components/shared/LoadingIndicator";

import { useModalContext } from "@shared/context/ModalContext";
import {
  useRegisteredWebhooks,
  useAllRegisteredWebhooks,
  useDeleteRegisteredWebhook,
} from "@shared/queryHooks/useRegisteredWebhooks";

function AccountIntegrationsPolymerWebhooks(props) {
  const addToast = useToastContext();
  const { openModal, removeModal } = useModalContext();
  const { history } = props;
  const { data: webhooksData, isLoading: isLoadingWebhooks } = useRegisteredWebhooks();
  const webhooks = webhooksData?.items || [];

  window.logger("%c[AccountIntegrationsPolymerWebhooks] webhooks", "color:rgb(25, 210, 56)", {
    webhooks,
  });

  const { mutate: saveAllWebhooks, isLoading: isLoadingSaveAll } = useAllRegisteredWebhooks();
  const { mutate: deleteWebhook } = useDeleteRegisteredWebhook();

  const newJobApplicationWebhook = webhooks && webhooks.find((w) => w.kind === "new_job_application");
  const newPublishedJobWebhook = webhooks && webhooks.find((w) => w.kind === "new_published_job");

  window.logger("%c[AccountIntegrationsPolymerWebhooks] intialNewJobApplicationWebhook", "color:rgb(25, 210, 56)", {
    newJobApplicationWebhook,
    newPublishedJobWebhook,
    newJobApplicationWebhookUrl: newJobApplicationWebhook?.url,
    newPublishedJobWebhookUrl: newPublishedJobWebhook?.url,
  });

  const [isDirty, setIsDirty] = React.useState(false);
  const [webhooksState, setWebhooksState] = React.useState({
    newJobApplicationWebhookUrl: newJobApplicationWebhook?.url || "",
    newPublishedJobWebhookUrl: newPublishedJobWebhook?.url || "",
  });

  React.useEffect(() => {
    if (webhooks && webhooks.length > 0) {
      const newJobApplicationWebhook = webhooks.find((w) => w.kind === "new_job_application");
      const newPublishedJobWebhook = webhooks.find((w) => w.kind === "new_published_job");
      
      setWebhooksState({
        newJobApplicationWebhookUrl: newJobApplicationWebhook?.url,
        newPublishedJobWebhookUrl: newPublishedJobWebhook?.url,
      });
    }
  }, [webhooks]);

  window.logger("%c[AccountIntegrationsPolymerWebhooks] webhooksState", "color:rgb(25, 210, 56)", {
    webhooksState,
  });

  const { newJobApplicationWebhookUrl, newPublishedJobWebhookUrl } = webhooksState;



  const updateRegisteredWebhookField = (name, value) => {
    setIsDirty(true);
    setWebhooksState({ ...webhooksState, [name]: value });
  };

  const onClickSubmit = (e) => {
    e.preventDefault();
    handleSubmit();
  };

  const handleSubmit = () => {
    const webhooksToUpdate = [
      {
        kind: "new_job_application",
        url: webhooksState.newJobApplicationWebhookUrl,
      },
      {
        kind: "new_published_job",
        url: webhooksState.newPublishedJobWebhookUrl,
      },
    ];

    saveAllWebhooks(webhooksToUpdate, {
      onSuccess: () => {
        setIsDirty(false);
        addToast({
          title: "Webhook settings saved",
          kind: "success",
        });
      },
      onError: () => {
        addToast({
          title: "Failed to save webhook settings",
          kind: "danger",
        });
      },
    });
  };

  const isLoading = isLoadingSaveAll || isLoadingWebhooks;

    if (isLoading || !webhooks) {
      return <LoadingIndicator label="Loading..." />;
    }


  const BottomBar = (
    <>
      <UnsavedChangesGuard
        hasUnsavedChanges={isDirty}
        navigate={(pathname) => {
          window.logger(
            "%c[AccountIntegrationsPolymerWebhooks] UnsavedChangesGuard navigate",
            "color: #1976D2",
            pathname,
          );
          setIsDirty(false);
          history.push(pathname);
        }}
      />

      <Button
        className="submit-button"
        type="button"
        onClick={onClickSubmit}
        disabled={isLoading}
        loading={isLoading}
        aria-label="Save changes"
      >
        Save changes
      </Button>
    </>
  );  

  return (
    <SettingsContainer
      title="Polymer Webhooks"
      description="Add webhook URLs that we will POST to when specific events occur."
      bottomBar={BottomBar}
      fullWidthForm={true}
    >
      <FormSection title="New job application webhook">
        <FormInput
          name="newJobApplicationWebhookUrl"
          onChange={updateRegisteredWebhookField}
          placeholder="https://your-site.com/webhook"
          label="Webhook URL"
          description="We will POST to this URL anytime a new job application is created."
          value={newJobApplicationWebhookUrl}
          errors={null}
          // iconName="trash"
          // onIconClick={() => handleClearWebhookUrl("new_job_application", "new job application")}
          iconDisabled={!newJobApplicationWebhookUrl}
        />
      </FormSection>

      <FormSection title="New job published webhook">
        <FormInput
          name="newPublishedJobWebhookUrl"
          onChange={updateRegisteredWebhookField}
          placeholder="https://your-site.com/webhook"
          label="Webhook URL"
          description="We will POST to this URL anytime a job is published."
          value={newPublishedJobWebhookUrl}
          errors={null}
          // iconName="trash"
          // onIconClick={() => handleClearWebhookUrl("new_published_job", "new job published")}
          iconDisabled={!newPublishedJobWebhookUrl}
        />
      </FormSection>
    </SettingsContainer>
  );
}

export default AccountIntegrationsPolymerWebhooks;
